// src/pages/VocationalSecundary.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/VocationalSecundary.css";
import Navbar from "../components/Navbar"; 

const PAGE_SIZE = 5;
const LS_KEY = (userId) => `vocationalSecundaryProgress:${userId}`;

const VocationalSecundary = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [responses, setResponses] = useState({});
  const [questions, setQuestions] = useState([]);
  const [userData, setUserData] = useState(null);
  const [showSidebar, setShowSidebar] = useState(false);
  const navigate = useNavigate();

  // 🔹 Guardar progreso en localStorage
  const persistLocal = (draft = {}) => {
    if (!userData?._id) return;
    const payload = {
      responses: draft.responses ?? responses,
      currentStep: draft.currentStep ?? currentStep,
      updatedAt: new Date().toISOString(),
      version: 1,
    };
    localStorage.setItem(LS_KEY(userData._id), JSON.stringify(payload));
  };

  // 🔹 Obtener usuario y cargar preguntas
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/users/me`, {
          headers: { Authorization: token },
        });
        setUserData(response.data);
      } catch (error) {
        console.error("Error al obtener usuario:", error);
      }
    };

    fetchUserData();

    // 🔹 Preguntas (mismo listado que tenías)
    const allQuestions = [
    
      {
        question: "¿Qué tipo de libros disfrutas leer?",
        options: [
          "Libros de ciencia y tecnología.",
          "Libros de historia y filosofía.",
          "Novelas y cuentos.",
          "Libros de autoayuda o psicología."
        ]
      },
      {
        question: "¿Qué asignatura te resulta más interesante en la escuela?",
        options: [
          "Matemáticas o física.",
          "Historia o geografía.",
          "Arte o música.",
          "Biología o química."
        ]
      },
      {
        question: "¿Te interesa descubrir cómo funcionan los dispositivos electrónicos?",
        options: [
          "Sí, me fascina la tecnología.",
          "Me interesa de forma moderada.",
          "No me interesa mucho.",
          "Prefiero otros temas."
        ]
      },
      {
        question: "¿Disfrutas de las actividades de laboratorio o experimentos?",
        options: [
          "Sí, me encantan.",
          "A veces.",
          "Rara vez.",
          "Nunca."
        ]
      },
      {
        question: "¿Te atrae la idea de aprender idiomas y culturas extranjeras?",
        options: [
          "Sí, mucho.",
          "Algo.",
          "Poco.",
          "Nada."
        ]
      },
      {
        question: "¿Te gusta investigar temas nuevos o realizar proyectos de investigación?",
        options: [
          "Sí, siempre.",
          "A veces.",
          "Rara vez.",
          "Nunca."
        ]
      },
      {
        question: "¿Qué te llama más la atención: los números o las letras?",
        options: [
          "Los números y fórmulas.",
          "Ambas por igual.",
          "Más las letras.",
          "Ninguna de las dos."
        ]
      },
      {
        question: "¿Te interesa el desarrollo de software o la programación?",
        options: [
          "Sí, me apasiona.",
          "Algo.",
          "Poco.",
          "No me interesa."
        ]
      },
      {
        question: "¿Te atrae el estudio de fenómenos naturales, como la física o la biología?",
        options: [
          "Sí, definitivamente.",
          "Moderadamente.",
          "Poco.",
          "Nada."
        ]
      },
      {
        question: "¿Prefieres aprender a través de la práctica que solo con teoría?",
        options: [
          "Sí, la práctica es fundamental.",
          "Depende del tema.",
          "Prefiero la teoría.",
          "No tengo preferencia."
        ]
      },
      {
        question: "¿Te interesa el uso de la tecnología para resolver problemas?",
        options: [
          "Sí, me entusiasma.",
          "Algo.",
          "No mucho.",
          "Para nada."
        ]
      },
      {
        question: "¿Te gustaría especializarte en áreas como robótica o inteligencia artificial?",
        options: [
          "Sí, me apasiona la idea.",
          "Quizás.",
          "No estoy seguro.",
          "No me interesa."
        ]
      },
      {
        question: "¿Te intriga el campo de la biotecnología?",
        options: [
          "Sí, mucho.",
          "Algo.",
          "Poco.",
          "Nada."
        ]
      },
      {
        question: "¿Qué te parece el estudio de las matemáticas avanzadas?",
        options: [
          "Muy interesante.",
          "Interesante, pero desafiante.",
          "Poco interesante.",
          "Nada interesante."
        ]
      },
      {
        question: "¿Te gustaría investigar y desarrollar nuevas tecnologías?",
        options: [
          "Sí, es mi pasión.",
          "Me gustaría intentarlo.",
          "No mucho.",
          "No me interesa."
        ]
      },
      // SECCIÓN 2 (16 a 30)
      {
        question: "¿Qué haces en tu tiempo libre?",
        options: [
          "Resolver problemas y puzzles.",
          "Leer e investigar temas de interés.",
          "Dibujar, pintar o crear algo.",
          "Socializar y ayudar a amigos."
        ]
      },
      {
        question: "¿Cómo te sientes al trabajar en equipo?",
        options: [
          "Prefiero liderar y organizar.",
          "Me gusta colaborar y aportar ideas.",
          "Prefiero trabajar solo, pero aporto creatividad.",
          "Me siento cómodo escuchando y apoyando."
        ]
      },
      {
        question: "¿Qué tan cómodo te sientes resolviendo problemas complejos?",
        options: [
          "Muy cómodo.",
          "Bastante cómodo.",
          "Algo incómodo.",
          "Nada cómodo."
        ]
      },
      {
        question: "¿Eres de los que disfruta experimentar con nuevas ideas?",
        options: [
          "Sí, siempre.",
          "A veces.",
          "Rara vez.",
          "Nunca."
        ]
      },
      {
        question: "¿Cómo te describirían tus profesores?",
        options: [
          "Analítico y metódico.",
          "Reflexivo y curioso.",
          "Creativo e innovador.",
          "Empático y colaborador."
        ]
      },
      {
        question: "¿Te gusta planificar y organizar actividades?",
        options: [
          "Sí, me encanta.",
          "Me gusta, pero sin presión.",
          "A veces.",
          "No me interesa."
        ]
      },
      {
        question: "¿Qué prefieres: trabajar con números o con ideas?",
        options: [
          "Con números y datos.",
          "Con ideas y conceptos.",
          "Una mezcla de ambos.",
          "Prefiero trabajar con personas."
        ]
      },
      {
        question: "¿Cómo manejas el estrés en situaciones de presión académica?",
        options: [
          "Mantengo la calma y busco soluciones.",
          "Me esfuerzo por controlarme.",
          "Me siento abrumado, pero lo soporto.",
          "Suelo necesitar ayuda."
        ]
      },
      {
        question: "¿Te consideras una persona innovadora?",
        options: [
          "Sí, muy innovador.",
          "Algo innovador.",
          "Poco innovador.",
          "No innovo."
        ]
      },
      {
        question: "¿Prefieres actividades que requieran precisión y lógica?",
        options: [
          "Sí, definitivamente.",
          "Me gustan, pero también disfruto de lo creativo.",
          "Prefiero lo artístico.",
          "No me gustan en absoluto."
        ]
      },
      {
        question: "¿Te gusta la idea de aprender mediante la práctica?",
        options: [
          "Sí, es mi forma ideal de aprender.",
          "Prefiero combinar teoría y práctica.",
          "Me inclino más por la teoría.",
          "No me gusta aprender de manera práctica."
        ]
      },
      {
        question: "¿Qué tan rápido aprendes conceptos nuevos?",
        options: [
          "Muy rápido.",
          "Con un poco de esfuerzo.",
          "Necesito tiempo para asimilarlos.",
          "Me cuesta mucho."
        ]
      },
      {
        question: "¿Te gusta investigar temas profundos y complejos?",
        options: [
          "Sí, me encanta profundizar.",
          "Me interesa moderadamente.",
          "Prefiero temas superficiales.",
          "No me interesa."
        ]
      },
      {
        question: "¿Te sientes cómodo usando herramientas digitales y tecnológicas?",
        options: [
          "Sí, muy cómodo.",
          "Bastante cómodo.",
          "Algo cómodo.",
          "Poco cómodo."
        ]
      },
      {
        question: "¿Cómo prefieres trabajar en proyectos?",
        options: [
          "De forma estructurada y analítica.",
          "Reflexionando y planificando.",
          "Con creatividad y espontaneidad.",
          "Colaborativamente y en equipo."
        ]
      },
      // SECCIÓN 3 (31 a 45)
      {
        question: "¿Cómo te imaginas tu futuro profesional?",
        options: [
          "Trabajando en investigación o desarrollando tecnología.",
          "Enseñando, investigando o en el ámbito académico.",
          "Creando proyectos artísticos o innovadores.",
          "Colaborando en proyectos que ayuden a la sociedad."
        ]
      },
      {
        question: "¿Qué valoras más en un trabajo?",
        options: [
          "La innovación y el desafío técnico.",
          "El conocimiento y la reflexión.",
          "La creatividad y la libertad de expresión.",
          "La interacción social y el impacto comunitario."
        ]
      },
      {
        question: "¿Qué te motiva a seguir estudiando?",
        options: [
          "La pasión por resolver problemas y descubrir nuevas soluciones.",
          "El deseo de entender el mundo y la historia.",
          "La inspiración para crear y expresarte artísticamente.",
          "La voluntad de contribuir al bienestar de los demás."
        ]
      },
      {
        question: "¿Qué importancia le das a la ética y la responsabilidad social?",
        options: [
          "Alta, creo que es fundamental en todo lo que hago.",
          "Moderada, trato de ser responsable.",
          "No lo considero primordial, pero es importante.",
          "Alta, especialmente si se trata de ayudar a la comunidad."
        ]
      },
      {
        question: "¿Cuánto te interesa participar en actividades extracurriculares?",
        options: [
          "Mucho, me gusta involucrarme en proyectos y talleres.",
          "Bastante, me gusta participar de vez en cuando.",
          "Algo, prefiero actividades académicas.",
          "Poco, me concentro en mis estudios."
        ]
      },
      {
        question: "¿Te gustaría trabajar en un ambiente dinámico y retador?",
        options: [
          "Sí, me entusiasma la idea.",
          "Me gustaría, pero sin excesiva presión.",
          "Prefiero ambientes tranquilos.",
          "No, prefiero entornos estables y previsibles."
        ]
      },
      {
        question: "¿Qué tan importante es para ti el reconocimiento profesional?",
        options: [
          "Muy importante, me motiva destacarme.",
          "Moderadamente importante.",
          "Poco importante, me enfoco en el proceso.",
          "No es importante para mí."
        ]
      },
      {
        question: "¿Te interesa trabajar en proyectos que tengan un impacto social?",
        options: [
          "Sí, es muy importante para mí.",
          "Algo, dependiendo del proyecto.",
          "No mucho, prefiero otras áreas.",
          "No, me enfoco en otros aspectos."
        ]
      },
      {
        question: "¿Cómo valoras el equilibrio entre vida personal y profesional?",
        options: [
          "Es fundamental para mí.",
          "Es importante, pero puedo sacrificarlo en ocasiones.",
          "No es mi prioridad.",
          "Depende del trabajo."
        ]
      },
      {
        question: "¿Qué tan dispuesto estás a aprender continuamente a lo largo de tu vida?",
        options: [
          "Muy dispuesto, me encanta aprender.",
          "Bastante dispuesto.",
          "Algo dispuesto.",
          "Poco dispuesto."
        ]
      },
      {
        question: "¿Qué tan importante es para ti la innovación en el ámbito profesional?",
        options: [
          "Muy importante.",
          "Moderadamente.",
          "Poco.",
          "Nada."
        ]
      },
      {
        question: "¿Prefieres proyectos que impliquen investigación y análisis?",
        options: [
          "Sí, definitivamente.",
          "A veces.",
          "No, prefiero actividades prácticas.",
          "No me interesa."
        ]
      },
      {
        question: "¿Te gustaría participar en concursos o ferias de ciencia y tecnología?",
        options: [
          "Sí, me entusiasma.",
          "Tal vez.",
          "Rara vez.",
          "No, no me interesa."
        ]
      },
      {
        question: "¿Qué tipo de actividades artísticas disfrutas más?",
        options: [
          "Pintura, escultura o fotografía.",
          "Música, teatro o danza.",
          "Diseño gráfico y multimedia.",
          "No me interesa el arte."
        ]
      },
      {
        question: "¿Participas en clubes o grupos de debate en la escuela?",
        options: [
          "Sí, frecuentemente.",
          "A veces.",
          "Rara vez.",
          "Nunca."
        ]
      },
      // SECCIÓN 4 (46 a 60)
      {
        question: "¿Te gusta colaborar en proyectos de servicio comunitario?",
        options: [
          "Sí, me apasiona ayudar.",
          "A veces.",
          "Rara vez.",
          "No me interesa."
        ]
      },
      {
        question: "¿Disfrutas de actividades al aire libre y deportivas?",
        options: [
          "Sí, mucho.",
          "Algo.",
          "Poco.",
          "Nada."
        ]
      },
      {
        question: "¿Te gustaría formar parte de equipos de innovación o emprendimiento?",
        options: [
          "Sí, me entusiasma.",
          "Tal vez.",
          "No, prefiero trabajar solo.",
          "No me interesa."
        ]
      },
      {
        question: "¿Te gusta experimentar con nuevas tecnologías (apps, gadgets, etc.)?",
        options: [
          "Sí, siempre.",
          "Frecuentemente.",
          "Rara vez.",
          "Nunca."
        ]
      },
      {
        question: "¿Qué tan importante es para ti la creatividad en tus actividades diarias?",
        options: [
          "Es esencial.",
          "Es importante.",
          "Es algo, pero no lo principal.",
          "No es relevante."
        ]
      },
      {
        question: "¿Te interesa la idea de desarrollar un proyecto personal (como un emprendimiento)?",
        options: [
          "Sí, me gustaría mucho.",
          "Tal vez, depende del proyecto.",
          "No mucho.",
          "No me interesa."
        ]
      },
      {
        question: "¿Prefieres un ambiente de estudio colaborativo?",
        options: [
          "Sí, me gusta trabajar en equipo.",
          "Prefiero una combinación de trabajo en grupo e individual.",
          "Me inclino más por el estudio individual.",
          "No tengo preferencia."
        ]
      },
      {
        question: "¿Te atrae la idea de tener un mentor o tutor para guiar tus proyectos?",
        options: [
          "Sí, me encantaría.",
          "Algo me gustaría.",
          "Poco.",
          "No lo considero."
        ]
      },
      {
        question: "¿Qué tan importante es para ti el uso de herramientas digitales en el aprendizaje?",
        options: [
          "Muy importante.",
          "Moderadamente.",
          "Poco.",
          "Nada."
        ]
      },
      {
        question: "¿Te gustaría aprender de forma autodidacta utilizando recursos en línea?",
        options: [
          "Sí, definitivamente.",
          "Con cierto apoyo.",
          "Prefiero clases presenciales.",
          "No."
        ]
      },
      {
        question: "¿Consideras que tienes una fuerte capacidad para innovar?",
        options: [
          "Sí, definitivamente.",
          "Algo.",
          "Poco.",
          "No."
        ]
      },
      {
        question: "¿Te interesa aplicar lo aprendido en proyectos reales o prácticos?",
        options: [
          "Sí, es fundamental para mí.",
          "Me gustaría en parte.",
          "No mucho.",
          "No."
        ]
      },
      {
        question: "¿Qué tan dispuesto estás a enfrentar desafíos académicos?",
        options: [
          "Muy dispuesto.",
          "Bastante.",
          "Algo dispuesto.",
          "Poco."
        ]
      },
      {
        question: "¿Valoras la retroalimentación para mejorar tu desempeño?",
        options: [
          "Sí, mucho.",
          "Algo.",
          "Poco.",
          "No."
        ]
      },
      {
        question: "¿Te ves estudiando en una institución que combine teoría y práctica?",
        options: [
          "Sí, es mi opción ideal.",
          "Me gustaría, pero no es decisivo.",
          "Prefiero más teoría.",
          "Prefiero solo práctica."
        ]
      },
    ];
    setQuestions(allQuestions);
  }, []);

  // 🔹 Cargar progreso guardado
  useEffect(() => {
    if (!userData?._id) return;
    try {
      const raw = localStorage.getItem(LS_KEY(userData._id));
      if (raw) {
        const saved = JSON.parse(raw);
        if (saved?.responses) setResponses(saved.responses);
        if (Number.isInteger(saved?.currentStep)) setCurrentStep(saved.currentStep);
      }
    } catch (e) {
      console.warn("No se pudo cargar el progreso local:", e);
    }
  }, [userData?._id]);

  const steps = Math.ceil(questions.length / PAGE_SIZE);

  const handleChange = (e, index) => {
    const next = { ...responses, [index]: e.target.value };
    setResponses(next);
    persistLocal({ responses: next });
  };

  const handleNext = () => {
    if (validateStep()) {
      setCurrentStep((prev) => {
        const next = prev + 1;
        persistLocal({ currentStep: next });
        return next;
      });
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handlePrev = () => {
    setCurrentStep((prev) => {
      const next = Math.max(prev - 1, 0);
      persistLocal({ currentStep: next });
      return next;
    });
  };

  const validateStep = () => {
    const start = currentStep * PAGE_SIZE;
    const end = Math.min(start + PAGE_SIZE, questions.length);
    for (let i = start; i < end; i++) {
      if (!responses[i]) {
        alert("Por favor, responde todas las preguntas antes de continuar.");
        return false;
      }
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    // ✅ Convertimos índices a puntajes reales (A=3, B=2, C=1, D=1)
    const scoringMap = [3, 2, 1, 1];
    const scoredResponses = {};
    Object.keys(responses).forEach((key) => {
      const index = parseInt(responses[key]);
      scoredResponses[key] = scoringMap[index];
    });

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/users/submit-vocational`,
        { responses: scoredResponses },
        { headers: { Authorization: token } }
      );

      if (response.status === 200) {
        alert("Cuestionario enviado con éxito");
        if (userData?._id) localStorage.removeItem(LS_KEY(userData._id));
        navigate("/dashboard");
      } else {
        alert("Hubo un problema al enviar el cuestionario");
      }
    } catch (error) {
      console.error("Error al enviar el cuestionario:", error);
      alert("Ocurrió un error. Intenta de nuevo.");
    }
  };

  const handleSaveAndExit = () => {
    persistLocal();
    alert("Progreso guardado localmente. Podrás continuar luego desde este equipo.");
    navigate("/dashboard");
  };

  const toggleSidebar = () => setShowSidebar(!showSidebar);
  const closeSidebar = () => setShowSidebar(false);

  return (
    <>
     <Navbar />

      <div className="dashboard-layout">
        <div className={`sidebar-overlay ${showSidebar ? "show" : ""}`} onClick={closeSidebar}></div>

        <div className={`dashboard-sidebar ${showSidebar ? "show" : ""}`}>
          <div className="sidebar-header">
            <h3>Orientación Vocacional</h3>
          </div>

          <div className="sidebar-menu">
            <div className="survey-progress">
              <div className="progress-info">
                <span>Progreso</span>
                <span>{currentStep + 1}/{steps}</span>
              </div>
              <div className="progress-bar">
                <div className="progress-fill" style={{ width: `${((currentStep + 1) / steps) * 100}%` }} />
              </div>
            </div>
          </div>

          <button
            className="menu-item return-dashboard"
            onClick={() => {
              if (window.confirm("¿Estás seguro de que deseas volver al dashboard? Tus respuestas se han guardado y podrás continuar luego.")) {
                handleSaveAndExit();
              }
            }}
          >
            <i className="bi bi-arrow-left-circle"></i>
            Volver al Dashboard
          </button>
        </div>

        <div className="dashboard-main">
          <div className="survey-container">
            <div className="survey-header">
              <h2>Cuestionario de Orientación Vocacional</h2>
              <p className="survey-description">
                Responde las siguientes preguntas para conocer tus áreas de afinidad.
              </p>
              <div className="button-container">
                <button 
                  type="button" 
                  className="nav-button prev"
                  onClick={handleSaveAndExit}
                >
                  <i className="bi bi-floppy"></i>
                  Guardar y salir
                </button>
              </div>
            </div>

            <form className="survey-form" onSubmit={handleSubmit}>
              <div className="questions-group">
                {questions
                  .slice(currentStep * PAGE_SIZE, (currentStep + 1) * PAGE_SIZE)
                  .map((q, index) => {
                    const globalIndex = index + currentStep * PAGE_SIZE;
                    return (
                      <div className="question-card" key={globalIndex}>
                        <div className="question-header">
                          <span className="question-number">
                            Pregunta {globalIndex + 1}
                          </span>
                          <p className="question-text">{q.question}</p>
                        </div>

                        <div className="options-grid">
                          {q.options.map((option, i) => (
                            <label
                              key={i}
                              className={`option-card ${responses[globalIndex] === String(i) ? "selected" : ""}`}
                            >
                              <input
                                type="radio"
                                name={`q${globalIndex}`}
                                value={i}
                                checked={responses[globalIndex] === String(i)}
                                onChange={(e) => handleChange(e, globalIndex)}
                                required
                              />
                              <span className="option-text">{option}</span>
                            </label>
                          ))}
                        </div>
                      </div>
                    );
                  })}
              </div>

              <div className="navigation-controls">
                {currentStep > 0 && (
                  <button type="button" className="nav-button prev" onClick={handlePrev}>
                    <i className="bi bi-arrow-left"></i>
                    Anterior
                  </button>
                )}
                {currentStep < steps - 1 ? (
                  <button type="button" className="nav-button next" onClick={handleNext}>
                    Siguiente <i className="bi bi-arrow-right"></i>
                  </button>
                ) : (
                  <button type="submit" className="nav-button submit">
                    Finalizar <i className="bi bi-check-circle"></i>
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default VocationalSecundary;
